import { render, staticRenderFns } from "./_table.vue?vue&type=template&id=1de7d9f5&scoped=true"
import script from "./_table.vue?vue&type=script&lang=js"
export * from "./_table.vue?vue&type=script&lang=js"
import style0 from "./_table.vue?vue&type=style&index=0&id=1de7d9f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de7d9f5",
  null
  
)

export default component.exports